module.exports = __webpack_public_path__ + "static/img/ico_second_place.a33017f4.png";